import icons from './icons.json'
import { dialogLabels } from '~/contents/benefits'

export const primecare: BenefitStoreContext[string] = {
	short_description: 'This plan provides you with instant access to high-quality healthcare.',
	description: 'Primecare covers you and your staff with quality health care',
	product_title: 'Unlock access to quality health cover',
	card_label:
		'Robust coverage at mcg_price/month, unlimited annual benefits, extensive healthcare access for essential needs. Reliable and comprehensive.',
	dialogLabels,
	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				"Your business unlocks more benefits when you consistently renew your subscription. If you fail to renew, your benefits reset, and you'll only have access to the initial benefits available from the 1st month when you repurchase the plan.",
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet. You can cancel the auto-renewal at any time by contacting our support team.',
				`You can start using your benefits ${WAITING_PERIOD} hours after receiving your HMO ID.`,
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			]
		},
		'Total Hospitals': {
			icon: icons.hospital,
			isOpen: false,
			key: 'hospital',
			value: [{ text: 'Your staff gains access to over 1200 hospitals across Nigeria.' }]
		},
		'Your Business Will Enjoy': {
			icon: icons.business,
			isOpen: false,
			value: [
				'Unlimited total benefit limits per policy.',
				'24/7 Healthcare Access: Free chats with doctors and nurses anytime, plus a free telemedicine app.',
				'Chronic Condition Coverage: Includes specialist consultations, medication, hospital admissions, and essential health equipment like BP machines and glucometers.',
				'Accident and Emergency Care: Covers resuscitative care, ICU services, ambulance transportation, and more.',
				'Fertility and Maternity Services: Covers fertility treatments up to ₦100,000, antenatal care, normal and assisted deliveries, C-sections, and neonatal care.',
				'Specialist and Preventive Care: Access to specialist consultations, surgeries up to ₦2,500,000, dental care up to ₦150,000, and comprehensive wellness checks.',
				'A digital HMO ID for each person.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Access to general and specialist consultations.',
				'24 hours telemedicine services: Chat with doctors and nurses.',
				'Coverage for hospital admissions and laboratory tests for chronic conditions.',
				'Fertility investigation and treatments up to ₦100,000 annually.',
				'Coverage for family planning services, contraceptives, and implants.',
				'Immunisation for children (0-5 years): Including BCG, OPV, DPT, IPV, Vitamin A, measles, yellow fever, meningitis, chickenpox, and pneumococcal.',
				'Additional immunisation coverage for 6 years and above: Including HPV Vaccine and Hepatitis B.',
				'Ambulance services and resuscitative care for accident and emergency cases, including basic radiological and laboratory investigations needed to stabilise the patient before being moved to the ICU if needed.',
				'Access to Intensive Care Unit (ICU): Including care for comatose patients, ventilator care, and more, for up to 7 days.',
				'Coverage for diagnostic services: Including X-rays, ultrasounds, CT scans, and MRIs.',
				'Coverage for laboratory tests: Including haematology, chemistry, microbiology, and serology.',
				'Private ward admissions, accommodation, and feeding for in-patient care, and up to 5 days of accommodation for parents whose infants are on admission.',
				'In-patient care and hospitalisation benefits abroad, up to ₦350,000.',
				'Provision of personal health equipment on medical diagnosis: Including BP machines, glucometers, and trackers.',
				'Ear, Nose & Throat (ENT) specialist care coverage.',
				'Access to routine eye tests and up to ₦45,000 coverage for lenses or frames annually.',
				'Primary and secondary dental care coverage up to ₦150,000.',
				'Up to 25 sessions for physiotherapy care, including drugs, annually.',
				'Coverage for minor, intermediate, and major surgeries up to ₦2,500,000.',
				'Protection for delivery and antenatal care: Including assisted deliveries and C-sections.',
				'Reimbursement for delivery abroad: Ranging from $180 for normal delivery to $300 for C-sections.',
				'Neonatal care: Including male circumcision, ear piercing, intensive care & life support, incubator care for 25 days up to ₦750,000.',
				'Renal care and dialysis for 20 sessions annually.',
				'Cancer care: Including consultation, admission, hospice, chemotherapy, and radiotherapy up to ₦2,000,000.',
				'Wellness checks: Including BMI, HIV, hypertension, diabetes, blood group, urinalysis, ECG, ALT/AST, prostate screening, mammogram, cervical smear (for women over 35 years), and general physical examinations.',
				'Access to HIV care and treatment services at designated approved centres.',
				'Mental health outpatient consultations for up to 12 weeks.',
				'Psychiatry care for outpatient mental illness cases, up to 6 weeks.',
				'15% discount on fitness and nutritional club membership (for non-network gyms).',
				'Network gym access: 2 sessions per week.',
				'After demise care and death cover up to ₦150,000.',
				'Diagnosis and line of treatment confirmation from secondary/tertiary care centres.'
			],
			need_to_know: [
				"Your business unlocks more benefits when you consistently renew your subscription. If you fail to renew, your benefits reset, and you'll only have access to the initial benefits available from the 1st month when you repurchase the plan.",
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet. You can cancel the auto-renewal at any time by contacting our support team.',
				`You can start using your benefits ${WAITING_PERIOD} hours after receiving your HMO ID.`,
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			],
			'How to get covered': [
				'Purchase the plan and add your staff.',
				'Ask the policyholders (your staff) to activate their plans, or do it yourself from your dashboard.',
				'After activation, the e-HMO ID will be automatically generated.',
				`${WAITING_PERIOD} hours after activation, your staff can present their HMO ID at any of the hospitals under the plan to receive healthcare.`
			]
		}
	}
}
